/** Catálogo e helpers de skills — espelho front do util do backend. */
export const SKILL_CATEGORIES = [
  {
    id: 'dev',
    label: 'Dev',
    hint: 'Código, engines e ferramentas',
    suggestions: [
      'Programador', 'Full Stack', 'Frontend', 'Backend', 'React', 'Node.js',
      'TypeScript', 'Python', 'Lua', 'C#', 'Java', 'SQL', 'API', 'DevOps',
    ],
  },
  {
    id: 'design',
    label: 'Design',
    hint: 'Visual, UI e identidade',
    suggestions: [
      'Designer', 'UI Designer', 'UX Designer', 'Figma', 'Photoshop',
      'Illustrator', 'Motion Design', 'Branding', '3D Artist',
    ],
  },
  {
    id: 'build',
    label: 'Build',
    hint: 'Construção e produção',
    suggestions: [
      'Builder', 'Level Designer', 'Map Maker', 'Arquiteto 3D',
      'Modelagem', 'Texturização', 'Iluminação', 'Ambientes',
    ],
  },
  {
    id: 'game',
    label: 'Game',
    hint: 'Games e Roblox',
    suggestions: [
      'Game Designer', 'Scripter', 'Roblox Studio', 'Unity', 'Unreal',
      'Systems Designer', 'Combat Designer', 'Quest Designer',
    ],
  },
  {
    id: 'soft',
    label: 'Soft',
    hint: 'Comunicação e liderança',
    suggestions: [
      'Líder', 'Comunicador', 'Mentor', 'Product Owner',
      'Community Manager', 'Escritor', 'Tradutor',
    ],
  },
  {
    id: 'other',
    label: 'Outro',
    hint: 'Skills livres',
    suggestions: [
      'Freelancer', 'Criador de Conteúdo', 'Streamer', 'Empreendedor',
    ],
  },
];

export const MAX_SKILLS = 12;
export const SKILL_NAME_MAX = 28;

export function normalizeSkillName(value) {
  return String(value || '')
    .trim()
    .replace(/\s+/g, ' ')
    .slice(0, SKILL_NAME_MAX);
}

export function normalizeSkillCategory(value) {
  const category = String(value || '').trim().toLowerCase();
  return SKILL_CATEGORIES.some((entry) => entry.id === category) ? category : 'other';
}

export function normalizeSkillLevel(value, fallback = 70) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return fallback;
  return Math.min(100, Math.max(1, Math.round(numeric)));
}

export function getSkillLevelLabel(level) {
  const value = normalizeSkillLevel(level, 0);
  if (value >= 90) return 'Expert';
  if (value >= 75) return 'Avançado';
  if (value >= 50) return 'Intermediário';
  if (value >= 25) return 'Básico';
  return 'Iniciante';
}

export function serializeSkills(skills) {
  if (!Array.isArray(skills)) return [];
  return skills
    .map((skill) => {
      if (!skill) return null;
      if (typeof skill === 'string') {
        const name = normalizeSkillName(skill);
        return name ? { name, category: 'other', level: 70 } : null;
      }
      const name = normalizeSkillName(skill.name);
      if (!name) return null;
      return {
        name,
        category: normalizeSkillCategory(skill.category),
        level: normalizeSkillLevel(skill.level, 70),
      };
    })
    .filter(Boolean);
}

export function skillsEqual(a, b) {
  const left = serializeSkills(a);
  const right = serializeSkills(b);
  if (left.length !== right.length) return false;
  return left.every((skill, index) => (
    skill.name === right[index].name
    && skill.category === right[index].category
    && skill.level === right[index].level
  ));
}

export function getCategoryMeta(categoryId) {
  return SKILL_CATEGORIES.find((entry) => entry.id === categoryId) || SKILL_CATEGORIES[SKILL_CATEGORIES.length - 1];
}
